import { hqHalfyearTopics, type HqControlResult, type HqControlSource } from '@kop/contracts';

export const controlTopics = hqHalfyearTopics.map(topic => ({ ...topic, purpose: ({
  'goals-policy': '연간 목표·경영방침', 'hazard-improvement': '위험요인과 개선 이행', budget: '예산 편성과 집행',
  'responsible-performance': '책임자별 업무수행 평가', 'appointment-staffing': '법정 선임과 인력 배치', 'worker-opinions': '의견 청취와 개선',
  'emergency-response': '매뉴얼과 훈련 이행', 'contractor-evaluation': '협력업체 평가와 후속조치',
  'legal-obligations': '관계법령 의무 이행', education: '교육 실시와 참석 현황',
} as Record<string, string>)[topic.id]! }));
export function controlSources(data: HqControlResult | null, topicId: string, featureId?: string) {
  return data?.sites.map(site => ({ ...site, sources: site.sources.filter(source => source.topicId === topicId && (!featureId || source.featureId === featureId))
    .map(source => ({ ...source, metrics: source.metrics.filter(metric => metric.key !== 'carried') })) })) ?? [];
}
export function controlTotals(sources: readonly HqControlSource[]) {
  const available = sources.filter(source => source.state === 'saved'), keys = [...new Set(available.flatMap(source => source.metrics.map(metric => metric.key)))];
  return keys.map(key => {
    const entries = sources.map(source => source.metrics.find(metric => metric.key === key));
    const metric = entries.find(Boolean)!;
    return { ...metric, value: sources.length > 0 && entries.every((entry, index) => sources[index]!.state === 'saved' && entry?.value !== null && entry?.value !== undefined && entry.period === metric.period) ? entries.reduce((sum, entry) => sum + entry!.value!, 0) : null };
  });
}
export function sourceStateLabel(source: HqControlSource) {
  return source.state === 'saved' || source.state === 'partial' ? '' : source.state === 'denied' ? '조회 불가' : source.state === 'not-connected' ? source.featureId ? '' : '자료 없음' : source.state === 'missing' ? '자료 없음' : '확인 필요';
}
export function sourceNotice(source: HqControlSource) {
  if (source.state === 'partial') return '';
  if (source.state === 'denied') return '이 사업장의 자료를 조회할 수 없습니다.';
  if (source.state === 'missing' || source.state === 'not-connected' && !source.featureId) return '등록된 자료가 없습니다.';
  if (source.state === 'unavailable') return '자료를 불러오지 못했습니다. 다시 시도해 주세요.';
  return '';
}
export const controlNumber = (value: number | null | undefined) => value == null ? '—' : value.toLocaleString('ko-KR');
